import React, { useState } from 'react';
import { Send, FileText, UploadCloud, Users } from 'lucide-react';
import { useCRM } from '../context/CRMContext';
import { useAuth } from '../context/AuthContext';

const Campaigns = () => {
  const { policies, activities, logActivity } = useCRM();
  const { user } = useAuth();
  
  const [subject, setSubject] = useState('Renueva tu seguro y obtén 10% de dcto');
  const [body, setBody] = useState('Hola [Nombre],\n\nTe recordamos que tu póliza actual terminará su vigencia pronto. Hemos asociado un nuevo enlace comercial para de renovación para agilizar tu trámite.\n\nNuestros asesores estarán a tu disposición si lo requieres.');
  
  const [selectedSeguro, setSelectedSeguro] = useState('Todos');
  const [isSending, setIsSending] = useState(false);
  const [linkType, setLinkType] = useState('renovacion');
  const [linkUrl, setLinkUrl] = useState('');

  // Filtramos la cantidad de contactos "Activos"
  const activeContacts = policies.filter(p => p.stage === 'active' && (selectedSeguro === 'Todos' || p.type === selectedSeguro));

  const handleLaunchCampaign = () => {
    if (!subject || !body) return alert("Completa el asunto y mensaje");
    setIsSending(true);
    
    // Simular el envío de campaña y registrarlo como Actividad Formal en BBDD
    setTimeout(() => {
      setIsSending(false);
      logActivity(`CAMPAÑA ENVIADA: [${subject}] > Destino: Pólizas ${selectedSeguro} (${activeContacts.length} contactos). Enlace: ${linkType}`);
      alert(`¡Campaña lanzada con éxito a ${activeContacts.length} asegurados!`);
    }, 1500);
  };

  return (
    <div className="animate-fade-in">
      <div style={{ marginBottom: '2rem' }}>
        <h1>Campañas de Marketing</h1>
        <p className="text-muted">Aviso de renovaciones, promociones cruzadas (Cross-Selling) y comunicados masivos.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(300px, 1fr) 2fr', gap: '2rem' }}>
        {/* Editor Panel */}
        <div className="card" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          <h3>Configurar Envío</h3>
          
          <div>
            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 500, marginBottom: '0.5rem' }}>Público Objetivo (Estado: Activos)</label>
            <select 
              value={selectedSeguro}
              onChange={(e) => setSelectedSeguro(e.target.value)}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border)', backgroundColor: 'var(--bg-color)' }}
            >
              <option value="Todos">Todas las pólizas</option>
              <option value="Auto">Seguros de Auto</option>
              <option value="Vida">Seguros de Vida</option>
              <option value="Hogar">Seguros de Hogar</option>
            </select>
            <p className="text-muted" style={{ fontSize: '0.8rem', marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
              <Users size={14} /> Se enviará a {activeContacts.length} contactos.
            </p>
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 500, marginBottom: '0.5rem' }}>Asunto del Correo</label>
            <input 
              type="text" 
              value={subject} 
              onChange={(e) => setSubject(e.target.value)} 
              style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border)' }} 
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 500, marginBottom: '0.5rem' }}>Mensaje Principal (Soporta Saltos de Línea)</label>
            <textarea 
              value={body}
              onChange={(e) => setBody(e.target.value)}
              rows={6}
              style={{ width: '100%', padding: '0.75rem', borderRadius: '4px', border: '1px solid var(--border)', resize: 'vertical', fontFamily: 'inherit' }}
            />
          </div>

          <div style={{ padding: '1rem', backgroundColor: 'var(--secondary)', borderRadius: '6px', border: '1px solid var(--border)' }}>
            <h4 style={{ fontSize: '0.9rem', marginBottom: '0.75rem' }}>Botón de Acción (Call to Action)</h4>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>Tipo de Enlace</label>
                <select 
                  value={linkType}
                  onChange={(e) => setLinkType(e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid var(--border)', backgroundColor: 'white' }}
                >
                  <option value="renovacion">Link de Renovación Estándar</option>
                  <option value="pago">Link de Portal de Pagos</option>
                  <option value="seguimiento">Link de Seguimiento (Siniestros)</option>
                  <option value="personalizado">Enlace Promocional Personalizado</option>
                </select>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: '0.25rem' }}>URL del Enlace</label>
                <input 
                  type="url" 
                  placeholder="https://veritasvas.cl/pagos/..." 
                  value={linkUrl}
                  onChange={(e) => setLinkUrl(e.target.value)}
                  style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid var(--border)' }} 
                />
              </div>
            </div>
          </div>

          <button 
            className="btn btn-primary" 
            style={{ marginTop: 'auto', justifyContent: 'center', opacity: isSending || activeContacts.length === 0 ? 0.6 : 1, pointerEvents: isSending || activeContacts.length === 0 ? 'none' : 'auto' }}
            onClick={handleLaunchCampaign}
          >
            {isSending ? 'Procesando Envío...' : (
              <>
                <Send size={18} />
                Lanzar Campaña
              </>
            )}
          </button>
        </div>

        {/* Preview Panel */}
        <div className="card" style={{ display: 'flex', flexDirection: 'column' }}>
          <h3 style={{ borderBottom: '1px solid var(--border)', paddingBottom: '1rem', marginBottom: '1.5rem' }}>Vista Previa Estándar</h3>
          
          <div style={{ flex: 1, backgroundColor: 'var(--bg-color)', borderRadius: 'var(--radius-md)', padding: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', border: '1px dashed var(--border)' }}>
            <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '8px', boxShadow: 'var(--shadow-md)', maxWidth: '400px', width: '100%' }}>
              <div style={{ textAlign: 'center', marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
                <img src="/logo.png" alt="Veritas Vas" style={{ height: '40px', objectFit: 'contain' }} />
              </div>
              <h2 style={{ color: 'var(--primary)', marginBottom: '1rem', fontSize: '1.25rem' }}>{subject || 'Escribe un asunto...'}</h2>
              <div style={{ color: 'var(--text-main)', fontSize: '0.9rem', marginBottom: '1.5rem', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>
                {body || 'Escribe un encabezado o redacta libremente para visualizar la estética...'}
              </div>
              
              <a 
                href={linkUrl || "#"} 
                className="btn btn-primary" 
                style={{ width: '100%', justifyContent: 'center', textDecoration: 'none', pointerEvents: 'none' }}
              >
                {linkType === 'pago' ? 'Pagar Ahora' 
                  : linkType === 'seguimiento' ? 'Ver Seguimiento de Caso' 
                  : linkType === 'personalizado' ? 'Ver Oferta Exclusiva' 
                  : 'Renovar Ahora'}
              </a>
              
              {linkUrl && (
                <p style={{ fontSize: '0.7rem', color: 'var(--text-muted)', marginTop: '1rem', wordBreak: 'break-all' }}>
                  Destino: {linkUrl}
                </p>
              )}

              <div style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid var(--border)', fontSize: '0.75rem', color: 'var(--text-muted)', textAlign: 'left' }}>
                Atentamente,<br/>
                <strong>Veritas Vas</strong><br/>
                Área de Soporte Comercial
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card" style={{ marginTop: '2rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>Historial de Envíos Masivos (Logs Oficiales)</h3>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)' }}>
                <th style={{ padding: '1rem 0', fontWeight: 600 }}>Campaña Target</th>
                <th style={{ padding: '1rem 0', fontWeight: 600 }}>Fecha Disparo</th>
                <th style={{ padding: '1rem 0', fontWeight: 600 }}>Operador Activo</th>
              </tr>
            </thead>
            <tbody>
              {activities.filter(a => a.text.includes('CAMPAÑA ENVIADA')).map(camp => {
                const [authorSection, actionDesc] = camp.text.split(': CAMPAÑA ENVIADA:');
                return (
                  <tr key={camp.id} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ padding: '1rem 0', color: 'var(--primary)', fontWeight: 500 }}>
                      {actionDesc?.trim() || camp.text}
                    </td>
                    <td style={{ padding: '1rem 0', color: 'var(--text-muted)' }}>{camp.time}</td>
                    <td style={{ padding: '1rem 0' }}>{authorSection}</td>
                  </tr>
                )
              })}
              {activities.filter(a => a.text.includes('CAMPAÑA ENVIADA')).length === 0 && (
                <tr>
                  <td colSpan={3} style={{ padding: '2rem 0', textAlign: 'center', color: 'var(--text-muted)' }}>Aún no se han enviado campañas de Marketing durante este período.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Campaigns;
